var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66622 13.4248C8.86273 12.7222 7.56376 11.4351 6.69835 10.6162C5.83292 9.85583 5.27635 10.499 4.22505 11.5524C3.04997 12.6644 4.22505 13.2489 5.8948 14.829L8.92465 17.6962C10.0378 18.6324 10.9652 17.2281 12.4491 15.8824L18.5088 10.0895C20.4254 8.33436 20.8581 8.33436 19.3123 6.93004C17.9522 5.58437 18.0141 5.58437 15.8498 7.6904C14.8605 8.56799 9.97605 13.2489 9.66637 13.4248L9.66622 13.4248Z",
    fill: "#10AA70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.8c25c655098a31dfce9575731ae92dc2.svg";
export { ForwardRef as ReactComponent };